import { render, staticRenderFns } from "./paWorkManage.vue?vue&type=template&id=56a4feeb&"
import script from "./paWorkManage.vue?vue&type=script&lang=js&"
export * from "./paWorkManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports